import {inject, ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Store, select} from '@ngrx/store';
import {BehaviorSubject, Observable} from 'rxjs';
import {Project} from 'src/app/core/model/project';
import {RewardCoin} from 'src/app/core/model/reward';
import {selectAllProjects} from 'src/app/core/store/projects/projects.selector';
import {GetTeamsAction} from 'src/app/core/store/teams/teams.action';
import {SuccessDialogComponent} from '../../dialog/success-dialog/success-dialog.component';
import {ProjectSelectorDialogComponent} from '../../projects/project-selector-dialog/project-selector-dialog.component';
import {ProjectsTaskDialogComponent} from '../projects-task-dialog/projects-task-dialog.component';
import {MobileService} from 'src/app/core/page/mobile.service';

@Component({
  selector: 'new-task-button',
  templateUrl: './new-task-button.component.html',
  styleUrls: ['./new-task-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewTaskButtonComponent {
  private readonly mobileService = inject(MobileService);
  @Input() onFinishedNewTask: () => void;
  @Input() coinTypes: RewardCoin[];
  @Input() selectedProject: Project;

  dialogRef: MatDialogRef<SuccessDialogComponent>;

  currentSkedIndex$ = new BehaviorSubject<number>(null);
  projects$: Observable<Project[]> = this.store$.pipe(select(selectAllProjects()));

  constructor(
    private dialog: MatDialog,
    private store$: Store
  ) {
    this.store$.dispatch(new GetTeamsAction({}));
  }

  openSuccessDialog(): void {
    this.dialogRef = this.dialog.open(SuccessDialogComponent, {
      autoFocus: this.mobileService.isMobilePlatform() ? false : undefined,
      data: 'Task added successfully',
      panelClass: 'project-selector-dialog',
    });
    setTimeout(() => {
      this.dialogRef.close();
    }, 1500);
  }

  openProjectsDialog(): void {
    if (this.selectedProject) {
      this.openTaskDialog(this.selectedProject);
      return;
    }

    const dialog = this.dialog.open(ProjectSelectorDialogComponent, {
      autoFocus: this.mobileService.isMobilePlatform() ? false : undefined,
      data: {projects: this.projects$, onFinishedNewTask: this.onFinishedNewTask, coinTypes: this.coinTypes},
      panelClass: 'project-selector-dialog',
    });
    dialog.afterClosed().subscribe(project => {
      if (project) {
        this.openTaskDialog(project);
      }
    });
  }

  openTaskDialog(project: Project) {
    const dialogRef = this.dialog.open(ProjectsTaskDialogComponent, {
      autoFocus: this.mobileService.isMobilePlatform() ? false : undefined,
      data: {project, fromCurrentSked: true, coinTypes: this.coinTypes, newTask: true},
      panelClass: 'task-dialog',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((manualEntry: boolean) => {
      if (this.onFinishedNewTask) {
        this.onFinishedNewTask();
      }
    });
  }
}
